export default function (campaign) {
  const {
    brands,
    ccdbReportEnabled,
    contributionType,
    endDate,
    finality,
    hierarchical,
    manager,
    marketCodes,
    masterKey,
    name,
    parent,
    recordType,
    startDate,
    status,
    type
  } = campaign

  return {
    brands: Array.isArray(brands) ? brands : [ brands ],
    ccdbReportEnabled,
    contributionType,
    endDate: endDate || null,
    finality,
    hierarchical,
    manager,
    marketCodes: Array.isArray(marketCodes) ? marketCodes : [ marketCodes ],
    masterKey,
    name,
    parent,
    recordType,
    startDate: startDate || null,
    status,
    type,
    config: buildConfig(campaign)
  }
}

function buildConfig (campaign) {
  const configObject = {}
  if (campaign.config.campaignData) {
    configObject.campaignData = campaign.config.campaignData
  }
  if (campaign.config.contentSelection) {
    configObject.contentSelection = campaign.config.contentSelection
  }

  return configObject
}
